export const ROLE = {
  STUDENT: 'student',
  EMPLOYER: 'employer',
  SUPER_ADMIN: 'superadmin',
}
